import { DashboardCard } from "@tellescope/ui";
import { TellescopeModelFromName, useTellescopeInfiniteQuery } from "@tellescope/tanstack-query";
import { useTranslation } from "react-i18next";
import { BlockPaginatedList } from "../BlockPaginatedList";
import { BlockEmptyState } from "../BlockEmptyState";

export interface EligibilityRecordsListProps {
  contact: TellescopeModelFromName<"endusers">;
}

export const EligibilityRecordsList = ({ contact }: EligibilityRecordsListProps) => {
  const { t } = useTranslation("contacts");
  const { data: eligibilityRecords, fetchNextPage } = useTellescopeInfiniteQuery({
    model: "enduser_eligibility_results",
    method: "getSome",
    request: {
      filter: {
        enduserId: contact.id,
      },
    },
    select: (data) => data.pages.flat(),
  });

  const hasInsurance = contact.insurance || contact.insuranceSecondary;

  if (hasInsurance && eligibilityRecords?.length) {
    return (
      <BlockPaginatedList className="flex-1 pr-2" scrollbar="floating" onBottomReached={() => fetchNextPage()}>
        {eligibilityRecords.map((result) => {
          const statusDisplay = result.statusText || result.status;
          const subtitle = result.type;
          const subtitleSecondary = result.results?.length
            ? t("{{count}} covered items", { count: result.results.filter((r) => r.is_covered).length })
            : statusDisplay;

          return (
            <DashboardCard
              key={result.id}
              statusLabel=""
              title={result.title}
              subtitle={subtitle}
              subtitleSecondary={subtitleSecondary}
              assignees={null}
              dueDate=""
              priority=""
              timestamp={undefined}
              className="mb-4 w-full"
            />
          );
        })}
      </BlockPaginatedList>
    );
  }

  return (
    <div className="flex flex-1 items-center justify-center pr-2">
      <BlockEmptyState>
        {hasInsurance ? t("No Eligibility Records for This Contact") : t("No Insurance Set for This Contact")}
      </BlockEmptyState>
    </div>
  );
};
